import { endpoints, request } from '!core/api';

export const trlStockExchangeMarketInputDataServices = {
  portInstrBalance: ({ account, symbol, exchange, securityType }) =>
    request.get(
      endpoints.backoffice(
        `wsbGetPortInstrBalance?account=${account}&symbol=${symbol}&exchange=${exchange}&securityType=${securityType}`,
      ),
    ),
};
